import { ComponentHelper } from "../core/util/componentHelper";
import { Helper } from "../core/util/helper";
import { IsSearchField } from "../core/components/isSearchField";
import { TextBox } from "../core/components/textBox";
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { CheckBox } from "../core/components/checkBox";
import { DatePicker } from "../core/components/datePicker";
import { DateTimePicker } from "../core/components/dateTimePicker";
import { TimePicker } from "../core/components/timePicker";
import { IndividualField, SelectionType } from "./editField";
import React from "react"


export default class EditDefaultValue extends React.Component<EditDefaultValueProps, EditDefaultValueState>{
    private maxLenght = 50;
    private factory = ComponentHelper.createFactory();
    private unicodeRegex: RegExp = /[^\x00-\x7F]/;
    private ref: React.Component;

    constructor(props: EditDefaultValueProps) {
        super(props);
        this.state = {
            currentDataType: props.entity.DataType,
            currentSelectionType: props.entity.SelectionType
        };
    }

    private setValue = (value: string) => {
        if (Helper.hasValue(value))
            value = value.substring(0, this.maxLenght);
        this.props.onChange(this.props.field, value);
        this.setState({})
    }

    private resetValue = () => {
        this.setValue(null);
    }

    componentDidUpdate() {
        if (this.props.entity.SelectionType != this.state.currentSelectionType) {
            this.setState({ currentSelectionType: this.props.entity.SelectionType }, this.resetValue);
        }

        if (this.props.entity.DataType != this.state.currentDataType) {
            this.setState({ currentDataType: this.props.entity.DataType }, this.resetValue);
        }
    }

    private renderComponent = () => {
        switch (this.state.currentSelectionType) {
            case SelectionType.MultiLangDropDownList:
            case SelectionType.ComboBox:
            case SelectionType.DropDownList:
            case SelectionType.EditBox:
                if (Helper.isNullOrEmpty(this.state.currentDataType))
                    return <></>;
                switch (this.state.currentDataType) {
                    //numerisch
                    case "int":
                        return this.renderNumericTextBox(-2147483648, 2147483647, 0);
                    case "bigint":
                        return this.renderNumericTextBox(-9223372036854775808, 9223372036854775807, 0);
                    case "smallint":
                        return this.renderNumericTextBox(-32768, 32767, 0);
                    case "decimal":
                        return this.renderNumericTextBox(-2147483648, 2147483647, 2, false);
                    case "float":
                        return this.renderNumericTextBox(-2147483648, 2147483647, 4, false);
                    case "bit":
                        return this.renderCheckbox();
                    //zeit


                    case "datetime":
                        return this.renderDateTimePicker();
                    case "time":
                        return this.renderTimePicker();
                    case "date":
                        return this.renderDatePicker();

                    default:
                        const allowUnicode = this.state.currentDataType != "char" && this.state.currentDataType != "varchar" && this.state.currentDataType != "text";
                        const maxLenght = (this.state.currentDataType == "char" || this.state.currentDataType == "nchar") ? 1 : this.maxLenght;
                        return this.renderTextBox(maxLenght, allowUnicode);
                }
            default: 
                return <><Selection value={this.props.value} selectionType={this.state.currentSelectionType} onChange={this.setValue} /></>;

        }       
    }

    private renderTextBox = (maxLenght: number = null, allowUnicode: boolean = true) => {
        if (maxLenght == null)
            maxLenght = this.maxLenght;
        const props = this.factory.getDefaultTextBoxProps();
        props.value = JSON.parse(JSON.stringify(this.props.value));
        props.field.maxLength = maxLenght;
        props.field.triggerOnChange = true;
        props.onChange = (_, value: string) => {
            if (!allowUnicode && this.unicodeRegex.test(value)) {
                value = this.props.value;
                setTimeout(() => {
                    this.ref.setState({ value: value });
                }, 0)
            } 
            this.setValue(value);
            
        }
        return <><TextBox {...props} ref={(r) => { this.ref = r; }} /></>;
    }

    private renderNumericTextBox = (min: number, max: number, decimals: number, floor: boolean = true) => {
        const props = this.factory.getDefaultNumericTextBoxProps();
        props.value = decimals > 0 ? kendo.parseFloat(this.props.value, "en-us") : kendo.parseInt(this.props.value);
        props.field.min = min;
        props.field.max = max;
        props.field.decimals = decimals;
        if (decimals > 0) {
            props.field.format = this.getFormat(decimals)
        }
        props.onChange = (_, value: number) => {
            if (floor)
                value = Math.floor(value);
            this.setValue(value.toString());
        }
        return <><IsNumericTextBox {...props} /></>;
    }

    private getFormat = (decimals: number) => {
        let result = "#.";
        for (let i = 0; i < decimals; i++) {
            result += "#";
        }
        return result;
    }


    private renderCheckbox = () => {
        const props = this.factory.getDefaultCheckBoxProps();
        const value = this.props.value;
        props.value = !Helper.isNullOrEmpty(value) && (value.toLowerCase() == "true" || value == "1");
        props.onChange = (_, value: boolean) => {
            this.setValue(value ? "1": "0");
        }
        return <><CheckBox {...props} /></>;
    }

    private renderDateTimePicker = () => {
        let value = this.props.value;
        if (!Helper.isNullOrEmpty(value)) {
            value = this.replaceAll(value, ".", "-").replace(" ", "T");
        }
        const props = this.factory.getDefaultDateTimePickerProps();
        props.value = value;
        props.onChange = (_, value: string) => {
            value = this.replaceAll(value, "-", ".").replace("T", " ");
            this.setValue(value);
        }
        return <><DateTimePicker {...props} /></>;
    }

    private renderTimePicker = () => {
        const props = this.factory.getDefaultTimeTextBoxProps();
        props.value = this.props.value;
        props.onChange = (_, value) => {
            const format = (value: number) => {
                if (value < 10)
                    return `0${value}`;
                return value.toString();
            }
            const date = new Date(value);
            this.setValue(`${format(date.getHours())}:${format(date.getMinutes())}`)
        }
        return <><TimePicker {...props} /></>;
    }

    private renderDatePicker = () => {
        let value = this.props.value;
        if (!Helper.isNullOrEmpty(value)) {
            value = this.replaceAll(value, ".", "-");
        }
        const props = this.factory.getDefaultDatePickerProps();
        props.value = value;
        props.onChange = (_, value: string) => {
            value = this.replaceAll(value, "-", ".").split("T")[0];
            this.setValue(value);
        }
        return <><DatePicker {...props} /></>;
    }


    private replaceAll = (value: string, from: string, to: string) => {
        if(value)
            return value.split(from).join(to)
        return "";
    }

    render() {
        return <>{this.renderComponent()}</>;
    }
}

interface EditDefaultValueProps {
    disabled: boolean;
    entity: IndividualField;
    field: any;
    onChange: (field, value: string) => void;
    value: string;

}

interface EditDefaultValueState {
    currentSelectionType: SelectionType;
    currentDataType: string;
}

class Selection extends React.Component<{ selectionType: SelectionType, onChange: (value) => void, value: string }, any>{
    private factory = ComponentHelper.createFactory();
    private selectionInfo: Map<SelectionType, SelectionInfo>;

    constructor(props) {
        super(props)
        this.init();
    }

    private init = () => {
        this.selectionInfo = new Map();
        this.selectionInfo.set(SelectionType.Address, { url: "Address", key: "adrnr"});
        this.selectionInfo.set(SelectionType.Machine, { url: "Machine", key: "maschnr"});
        this.selectionInfo.set(SelectionType.Project, { url: "Project", key: "projnr"});
        this.selectionInfo.set(SelectionType.Resource, { url: "Resource", key: "ressnr" });
        this.selectionInfo.set(SelectionType.Contact, { url: "Contact", key: "pos" });
        this.selectionInfo.set(SelectionType.Ticket, { url: "Procedure", key: "problemnr"});
        this.selectionInfo.set(SelectionType.User, { url: "User", key: "name"});
    }

    render() {
        const info = this.selectionInfo.get(this.props.selectionType);
        if (!Helper.hasValue(info))
            return null;
        const props = this.factory.getDefaultSearchFieldProps();
        props.value = this.props.value;
        props.field.readOnlyTextField = true;
        props.field.searchWindowUrl = `DynamicSearch/Window/${info.url}?fullObject=true`;        
        props.handleIsSearchFieldFullObjectModel = (_, dataItem) => {
            const value = Helper.getAttributeSavely(dataItem, info.key);
            this.props.onChange(value);
        }
        return (
            <>
                <IsSearchField {...props}/>
            </>
        );
    }
}

interface SelectionInfo {
    url: string;
    key: string;
}